import React from 'react';

import HighlightsEditor from './Editors/Highlights';
import PriceEditor from './Editors/TrekPriceEditor';
import BasicInfoEditor from './Editors/BasicInfo';
import TrekNameAndDate from './Editors/TrekNameAndDate';
import Description from './Editors/Description';
import TerrainInfoEditor from './Editors/TerrainInfo';
import PreferencesEditor from './Editors/Preferences';
import TrekCTAAndPrice from './Editors/TrekCTAAndPrice';

// import EditNotifications from '../../screens/Trek/EditNotifications';
import EditNotifications from './UiNotifications';
import LockTrek from './LockTrek';

export const modalUiComponent = {
  TrekNameAndDateEditor: props => <TrekNameAndDate {...props} />,
  BasicInfoEditor: () => <BasicInfoEditor />,
  PriceEditor: () => <PriceEditor />,
  HighlightsEditor: () => <HighlightsEditor />,
  DescriptionEditor: () => <Description />,
  TerrainInfoEditor: () => <TerrainInfoEditor />,
  PreferencesEditor: () => <PreferencesEditor />,
  UseTemplate: () => <EditNotifications type="UseTemplate" />,
  RequestToJoin: () => <EditNotifications type="RequestToJoin" />,
  LoginToJoin: () => <EditNotifications type="LoginToJoin" />,
  LoginToUseTemplate: () => <EditNotifications type="LoginToUseTemplate" />,
  OnlyOwnerCanEdit: () => <EditNotifications type="OnlyOwnerCanEdit" />,
  NeedToBeAGuide: () => <EditNotifications type="NeedToBeAGuide" />,
  LockTrek: () => <LockTrek />,
  TrekCTAAndPriceEditor: () => <TrekCTAAndPrice />,
};

export const ModalUi = ({ component, props }) =>
  modalUiComponent[component] ? modalUiComponent[component](props) : null;

export const componentNames = Object.keys(modalUiComponent).reduce(
  (allKeys, key) => ({ ...allKeys, [key]: key }),
  {}
);



// WEBPACK FOOTER //
// ./src/components/TrekDetail/TrekOverviewModal.jsx